import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { MapControlsContainer, LabeledToggleControl, LassoControl } from '../../../components/LeafletMap';
import { dictionary } from '../../../lang';
import { MAP_TYPE } from '../../../lib/constants';
import { TeamMapContext } from '.';
const TeamMapControlsBar = () => {
    const { heatMap, displayPins, toggleDisplayPinsMode, isPinsScoreMode, togglePinsScoreMode, drawMode, handleDrawModeChange, } = useContext(TeamMapContext);
    return (_jsxs(MapControlsContainer, { children: [displayPins && (heatMap === MAP_TYPE.PIN_SCORE) && (_jsx(LabeledToggleControl, { label: dictionary.PIN_SCORE, checked: isPinsScoreMode, onChange: togglePinsScoreMode })), _jsx(LabeledToggleControl, { label: dictionary.HIDE_PINS, checked: displayPins, onChange: toggleDisplayPinsMode }), _jsx(LassoControl, { drawMode: drawMode, changeDrawMode: handleDrawModeChange })] }));
};
export default TeamMapControlsBar;
